import React from 'react';
import PropTypes from 'prop-types';
import CategoryProp from './propTypes/categoryProp';
import AttributeProp from './propTypes/attributeProp';

/**
 * Member header popup, displaying profiles, logout, etc
 * Note: possibly notifications in case they're implemented in the project, should
 * require little refactoring
 */
export default function ShopCategoryDropdown({
  t,
  query,
  productType,
  handleQueryChange,
  categories,
}) {
  const allCategories = [{ _id: '', name: t('all') }].concat(categories);

  return (
    <div className="m-dropdown__content shopDropdown">
      {allCategories.map(c => (
        <button
          key={c.id}
          type="button"
          className={`py-2 clickable shopDropdownItem ${
            query.category === c._id && query.productType === productType
              ? 'active'
              : ''
          }`}
          onClick={() =>
            handleQueryChange({
              productType,
              category: c._id,
            })
          }
        >
          {c.name}
        </button>
      ))}
    </div>
  );
}

ShopCategoryDropdown.propTypes = {
  query: PropTypes.shape({
    category: PropTypes.string,
    maxPrice: PropTypes.number,
    attributes: PropTypes.shape(AttributeProp.propType),
    sort: PropTypes.number,
    search: PropTypes.number,
    productType: PropTypes.string,
  }).isRequired,
  productType: PropTypes.string.isRequired,
  handleQueryChange: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape(CategoryProp.propType))
    .isRequired,
  t: PropTypes.func.isRequired,
};
